import { TextCaption } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutContext } from 'contexts/LayoutContext';
import { BottomSheetHeader } from '@/design-system/components/headers';
import BottomSheet, { useBottomSheetDynamicSnapPoints, BottomSheetBackdrop } from '@gorhom/bottom-sheet';
import { Icon } from '@/design-system/components/icons/Icon';
import { CardDetailStackRoutes, CardDetailStackScreenProps } from './type';

export const CardDetailDailyLimitTypesNative: React.FC<CardDetailStackScreenProps<CardDetailStackRoutes.DailyLimitTypes>> = ({
  navigation,
  route
}) => {
  const { theme } = useDripsyTheme();
  const { onLayout } = route.params;
  const { t } = useTranslation('account-management');
  const { body, textMb, textTitle, textAtmPin, btnView, btn, modal, topHeader } = sxStyles;

  const layout = useContext(LayoutContext);
  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );
  const { width, height } = layout.dimensions;
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);

  return (
    <View sx={{ width, height, backgroundColor: 'transparent' }}>
      <BottomSheet
        enablePanDownToClose
        index={1}
        snapPoints={animatedSnapPoints}
        handleHeight={animatedHandleHeight}
        contentHeight={animatedContentHeight}
        backdropComponent={renderBackdrop}
        handleComponent={() => <View />}>
        <View sx={modal}>
          <View sx={{ minHeight: 176, backgroundColor: '$backgroundPrimary' }} onLayout={handleContentLayout}>
            <View sx={topHeader}>
              <BottomSheetHeader title="Daily Limit Types" onPress={() => navigation.goBack()} />
            </View>
            <View sx={body}>
              <View sx={{ gap: '$5', py: '$5' }}>
                <View sx={{ flexDirection: 'row', alignItems: 'center', gap: '$2' }}>
                  <Icon name="purchaseLimit" width={20} height={20} />
                  <TextCaption sx={{ color: '#1A1A1A' }}>Purchase Limit</TextCaption>
                </View>
                <View sx={{ flexDirection: 'row', alignItems: 'center', gap: '$2' }}>
                  <Icon name="atmLimit" width={20} height={20} />
                  <TextCaption sx={{ color: '#1A1A1A' }}>ATM Withdrawal Limit</TextCaption>
                </View>
              </View>
            </View>
          </View>
        </View>
      </BottomSheet>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    width: '100%',
    padding: '$4'
  },
  body: {},
  textMb: {
    marginBottom: 20
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btnView: {
    flex: 1,
    display: 'grid',
    gap: '$3',
    mt: '$15'
  },
  btn: {
    width: '100%',
    height: 44
  }
};
